import { AssetLoadError, isStylesheetReady, loadStylesheet } from "@/lib/asset-recovery";

let complete = false;
let pending: Promise<void> | undefined;
let failure: Error | undefined;
let initialReady = false;
let initialPending: Promise<void> | undefined;
let initialFailure: Error | undefined;

// Initial SSR already includes the correct stylesheet. Before any SPA route
// changes, load the unchanged complete stylesheet while Suspense retains the
// old page. Keep it for every subsequent navigation, including Back/Forward.
export default function RouteStyles({ path }: { path: string }) {
  if (typeof document === "undefined" || complete) return null;
  const initial = document.querySelector<HTMLLinkElement>("link[data-route-css]");
  if (!initial) return null;
  if (initial.dataset.routePath === path) {
    if (isStylesheetReady(initial) || initialReady) return null;
    if (initialFailure) throw initialFailure;
    if (!initialPending) {
      initialPending = loadStylesheet(initial.href).then(
        () => { initialReady = true; },
        (error: Error) => { initialFailure = error; throw error; },
      );
    }
    throw initialPending;
  }
  if (failure) throw failure;
  if (!pending) {
    const href = initial.dataset.fullCss;
    if (!href) throw new AssetLoadError("Missing complete stylesheet URL");
    pending = loadStylesheet(href).then(
      () => { complete = true; },
      (error: Error) => { failure = error; throw error; },
    );
  }
  throw pending;
}
